import { motion } from "framer-motion";
import { Phone, ArrowRight } from "lucide-react";
import { BUSINESS, IMAGES } from "@/data/site";

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[90vh] items-center overflow-hidden" data-testid="hero-section">
      <img
        src={IMAGES.hero}
        alt="Southern Cross style multi-blade farm windmill with water tank against a clear blue sky"
        className="absolute inset-0 h-full w-full object-cover object-[center_25%]"
      />
      <div className="absolute inset-0 bg-black/70" />
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-zinc-950 to-transparent" />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 py-24 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="font-mono-industrial text-xs font-semibold uppercase tracking-[0.25em] text-orange-500"
          data-testid="hero-overline"
        >
          Rural contracting · Water, wind &amp; wire · {BUSINESS.area}
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45, delay: 0.1 }}
          className="mt-6 max-w-4xl font-display text-5xl font-black uppercase leading-[0.95] tracking-tighter text-white sm:text-6xl lg:text-7xl"
          data-testid="hero-headline"
        >
          Windmills. Water. Fencing.
          <span className="block text-orange-600">Done right, first time.</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45, delay: 0.2 }}
          className="mt-6 max-w-2xl text-base leading-relaxed text-zinc-300 lg:text-lg"
          data-testid="hero-subtext"
        >
          Repairs, installs and plumbing for farms, properties and homes — backed by free
          written quotes, fast turnaround and fully licensed &amp; insured work.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45, delay: 0.3 }}
          className="mt-10 flex flex-col gap-4 sm:flex-row"
        >
          <a
            href="#quote"
            data-testid="hero-quote-button"
            className="inline-flex items-center justify-center gap-2 border border-orange-600 bg-orange-600 px-8 py-4 font-bold uppercase tracking-wider text-white transition-colors duration-150 hover:bg-orange-500"
          >
            Get a Free Written Quote <ArrowRight className="h-5 w-5" />
          </a>
          <a
            href={`tel:${BUSINESS.phone}`}
            data-testid="hero-call-button"
            className="inline-flex items-center justify-center gap-2 border border-zinc-600 bg-zinc-900/80 px-8 py-4 font-bold uppercase tracking-wider text-orange-500 transition-colors duration-150 hover:border-orange-500 hover:bg-zinc-800"
          >
            <Phone className="h-5 w-5" /> Call {BUSINESS.phone}
          </a>
        </motion.div>
      </div>
    </section>
  );
}
